const steps = [
    {
        n: "01",
        title: "Diagnóstico & Metas SMART",
        desc: "Em 10 minutos, você descobre exatamente onde está travando e define metas mensuráveis para os próximos 30 dias.",
    },
    {
        n: "02",
        title: "Vocabulário em contexto",
        desc: "Pare de decorar listas. Aprenda as palavras e expressões que aparecem em 80% das conversas reais.",
    },
    {
        n: "03",
        title: "Listening inteligente",
        desc: "Treine o ouvido com áudios curtos, Language Reactor e a técnica do Shadowing que muda sua pronúncia em dias.",
    },
    {
        n: "04",
        title: "Speaking sem travar",
        desc: "Aplique “Talking to Myself” e Active Recall: você começa a falar em voz alta desde o Dia 1 — mesmo sozinho.",
    },
    {
        n: "05",
        title: "Gramática sem travar",
        desc: "Aprenda só as 6 estruturas que importam. O resto, o cérebro absorve sozinho com exposição.",
    },
    {
        n: "06",
        title: "Plano prático de 30 dias",
        desc: "Cronograma diário com tarefas de 20–40 min. Você abre, executa, e fecha sabendo que avançou.",
    },
];

export default function HowItWorks() {
    return (
        <section
            id="how-it-works"
            data-testid="section-how-it-works"
            className="bg-white py-24 lg:py-32 border-y border-cream"
        >
            <div className="max-w-6xl mx-auto px-5 sm:px-8 lg:px-12">
                <div className="max-w-3xl reveal">
                    <div className="flex items-center gap-3 mb-5">
                        <span className="hairline w-10" />
                        <span className="label-eyebrow">Como funciona</span>
                    </div>
                    <h2 className="font-serif text-emerald-brand text-3xl sm:text-4xl lg:text-5xl leading-[1.08] tracking-tight">
                        6 passos.{" "}
                        <span className="italic text-gold-brand">30 dias</span>.
                        Resultado real.
                    </h2>
                    <p className="mt-5 text-lg text-emerald-light/85 leading-relaxed">
                        Cada etapa foi desenhada para destravar uma camada
                        específica do bloqueio — começando pela mais profunda:
                        sua relação com o idioma.
                    </p>
                </div>

                <div className="mt-16 relative">
                    <div className="absolute left-[27px] sm:left-[31px] top-2 bottom-2 w-px bg-gradient-to-b from-gold-brand/0 via-gold-brand/40 to-gold-brand/0" />
                    <div className="space-y-8">
                        {steps.map((s, i) => (
                            <div
                                key={i}
                                className="reveal relative flex gap-6 sm:gap-8 group"
                                data-testid={`step-${i}`}
                            >
                                <div className="shrink-0 w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-emerald-brand text-gold-brand font-serif text-xl flex items-center justify-center border-4 border-cream relative z-10 group-hover:scale-105 transition-transform">
                                    {s.n}
                                </div>
                                <div className="flex-1 pb-2">
                                    <h3 className="font-serif text-emerald-brand text-2xl sm:text-3xl leading-tight">
                                        {s.title}
                                    </h3>
                                    <p className="mt-2 text-emerald-light/85 text-base sm:text-lg leading-relaxed max-w-2xl">
                                        {s.desc}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
